import minutes from './minutes';
import aimType from './aimType';
import behaviourType from './behaviourType';
import percent from './percent';

export default {
  install(Vue) {
    Vue.filter('minutes', minutes);
    Vue.filter('aimType', aimType);
    Vue.filter('behaviourType', behaviourType);
    Vue.filter('percent', percent);
  },
};


// WEBPACK FOOTER //
// ./src/modules/dro/filters/index.js